import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FiArrowRight, FiCheck, FiLock, FiTrendingUp, FiX } from "react-icons/fi";
import { FREE_TOOL_LIMIT, TOOL_LIMIT_EVENT } from "./toolUsage";
import "./ToolUsagePrompt.css";

export default function ToolUsagePrompt() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(TOOL_LIMIT_EVENT, show);
    return () => window.removeEventListener(TOOL_LIMIT_EVENT, show);
  }, []);
  return (
    <Modal show={open} onHide={() => setOpen(false)} centered className="tool-limit-modal" aria-labelledby="tool-limit-title" aria-describedby="tool-limit-description">
      <Modal.Body className="tool-limit-body">
        <button type="button" className="tool-limit-close" onClick={() => setOpen(false)} aria-label="Close"><FiX aria-hidden="true" /></button>
        <div className="tool-limit-hero">
          <span className="tool-limit-eyebrow">YOUR NEXT STEP WITH SEOBIX</span>
          <div className="tool-limit-symbol"><FiTrendingUp aria-hidden="true" /><span><FiLock aria-hidden="true" /></span></div>
          <h2 id="tool-limit-title">Your free searches<br />are <span>used up.</span></h2>
          <p id="tool-limit-description">You’ve explored your {FREE_TOOL_LIMIT} free tool requests.<br />Keep discovering opportunities to grow.</p>
        </div>
        <div className="tool-limit-usage">
          <div><span>Free tool requests</span><strong>{FREE_TOOL_LIMIT} of {FREE_TOOL_LIMIT} used</strong></div>
          <div className="tool-limit-meter" aria-hidden="true">{Array.from({ length: FREE_TOOL_LIMIT }, (_, index) => <span key={index} />)}</div>
          <p><FiCheck aria-hidden="true" /> Free allowance completed</p>
        </div>
        <div className="tool-limit-actions">
          <p>Log in to your SeoBix dashboard or choose<br className="tool-limit-desktop-break" /> a plan to continue using the tools.</p>
          <a className="tool-limit-primary" href="https://dashboard.seobix.com/">Log in to continue <FiArrowRight aria-hidden="true" /></a>
          <a className="tool-limit-secondary" href="/pricing-plans">Explore plans <FiArrowRight aria-hidden="true" /></a>
          <button type="button" className="tool-limit-later" onClick={() => setOpen(false)}>Maybe later</button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
